// extracted by mini-css-extract-plugin
export default {"mainDiv":"card_mainDiv__WSZuQ"};